import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Button, CircularProgress, Alert } from '@mui/material';
import { Print } from '@mui/icons-material';
import api from '../../services/api';
import { WorkIssueVoucher } from '../karigar/WorkIssueList';

const ShopWorkIssueList = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const karigarParam = params.get('karigar') || '';
  const karatParam = params.get('karat') || '';

  const [karigar, setKarigar] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      if (!karigarParam) { setError('Karigar parameter is required'); setLoading(false); return; }
      try {
        const [karigarRes, itemsRes] = await Promise.all([
          api.get('/api/karigar'),
          api.get(`/api/shop/work-issued?karigar=${karigarParam}`)
        ]);
        setKarigar(karigarRes.data.find(k => k.abbreviation === karigarParam) || null);
        setItems(itemsRes.data || []);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [karigarParam]);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}><CircularProgress /></Box>;
  if (error) return <Box sx={{ p: 4 }}><Alert severity="error">{error}</Alert></Box>;

  return (
    <Box>
      <Box className="no-print" sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" startIcon={<Print />} onClick={() => window.print()}>Print</Button>
      </Box>
      <WorkIssueVoucher karigar={karigar} items={items} karatParam={karatParam} />
      <style>{`
        @media print {
          .no-print { display: none !important; }
          @page { size: A4 landscape; margin: 8mm; }
          body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
        }
      `}</style>
    </Box>
  );
};

export default ShopWorkIssueList;
